import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserLayout } from '../layout';
import EndroitDetailContent from './EndroitDetailContent';
import { getPlaceByLocalUuid, getUserPlaces } from '../../services/userPlacesService';
import { storage } from '../../services/storageService';

const DASHBOARD_PAGE_KEY = 'cabaza_dashboard_page';

/**
 * Dashboard Endroit Detail Page
 * Full page with layout (header, menu, content, footer)
 * Supports both private places (localUuid from localStorage) and public places (placeUuid from DB)
 */
const EndroitDetail = ({ onLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [localPlace, setLocalPlace] = useState(undefined); // undefined = not yet resolved

    // Get the current dashboard page from localStorage to highlight correct menu item
    const currentDashboardPage = storage.getItem(DASHBOARD_PAGE_KEY) || 'endroits';

    // Handle navigation from menu - save page and go to dashboard
    const handleNavigate = (page) => {
        storage.setItem(DASHBOARD_PAGE_KEY, page);
        navigate('/');
    };

    // Try to find the place in localStorage first
    useEffect(() => {
        if (!id) return;
        const userId = parseInt(storage.getItem('userId') || '0', 10);
        if (!userId) {
            setLocalPlace(null);
            return;
        }
        // First try cache (synchronous)
        const cached = getPlaceByLocalUuid(userId, id);
        if (cached) {
            setLocalPlace(cached);
            return;
        }
        // If not in cache, load all places then search by localUuid OR placeUuid
        getUserPlaces(userId).then(places => {
            const found = places.find(p =>
                p.localUuid === id || p.localId === id || p.placeUuid === id
            );
            setLocalPlace(found || null);
        }).catch(() => {
            setLocalPlace(null);
        });
    }, [id]);

    // Wait until we know if this is a local or public place
    if (localPlace === undefined) return null;

    // A place is "local" (private, stored in localStorage) if it has no placeUuid
    const isLocal = localPlace !== null && !localPlace?.placeUuid;

    return (
        <UserLayout
            currentPage={currentDashboardPage}
            onNavigate={handleNavigate}
            onLogout={onLogout}
        >
            <EndroitDetailContent
                placeData={localPlace}
                isLocal={isLocal}
            />
        </UserLayout>
    );
};

export default EndroitDetail;
